import { useScopedTranslate } from '@locale/translate';

import { ViewsProviderProps, getDefaultColumnState } from './helpers';
import { ViewSettingsModal } from './view-settings-modal';

import { AvailableColumn, DataItemType, TableView } from '../types';

export const CreateViewModal = <DataItem extends DataItemType = DataItemType>({
  createView,
  availableColumns = [],
  initialView,
}: Pick<ViewsProviderProps, 'createView'> & {
  availableColumns?: Array<AvailableColumn<DataItem>>;
  initialView?: TableView;
}): JSX.Element => {
  const { t } = useScopedTranslate(locale);

  return (
    <ViewSettingsModal
      defaultName=""
      defaultIsCollaborative={initialView?.isCollaborative !== false}
      title={t('createView')}
      saveText={t('createView')}
      onSave={(name, isCollaborative) => {
        let newView: TableView;
        if (initialView) {
          newView = { ...initialView, id: `view-${Date.now()}`, name, isCollaborative };
        } else {
          const { columnOrder, columnVisibility } = getDefaultColumnState(availableColumns);
          newView = {
            id: `view-${Date.now()}`,
            name,
            appliedFilters: [],
            columnOrder,
            columnSizing: {},
            columnVisibility,
            conjunction: 'and',
            isCollaborative,
          };
        }
        createView(newView);
      }}
    />
  );
};

const locale = {
  en: {
    createView: 'Create view',
  },
  is: {
    createView: 'Búa til ásýnd',
  },
};
